const users = [
  {
    idUser: 1,
    avatar: 'fotoperfil1.jpg',
    name: 'Lucía',
    lastName: 'Rodríguez',
    city: 'Cáceres'
  },
  {
    idUser: 2,
    avatar: 'fotoperfil2.jpg',
    name: 'Sofía',
    lastName: 'Guijuela',
    city: 'Albacete'
  },
  {
    idUser: 3,
    avatar: 'fotoperfil3.jpg',
    name: 'Isaac',
    lastName: 'Martin',
    city: 'Granada'
  },
  {
    idUser: 4,
    avatar: 'fotoperfil4.jpg',
    name: 'Juan Antonio',
    lastName: 'Torres',
    city: 'La Langa'
  }
]
export default function getUser (id) {
  const options = {
    1: { ...users[0] },
    2: { ...users[1] },
    3: { ...users[2] },
    4: { ...users[3] }
  }
  console.log(id)
  return options[id]
}
